// src/pages/ProjectsPage.js
import React from "react";
import { Projects } from "../components/projects";

export const ProjectsPage = () => {
  return (
    <div className="standalone-page">
      <Projects />
    </div>
  );
};